import React, { useState, useEffect } from "react";
import {
  StyleSheet,
  View,
  Text,
  TouchableOpacity,
  Platform,
} from "react-native";

import AppConfig from "../../../config/AppConfig";

import { isWeb, navigate, openURL } from "../../../helpers/utils";

import AppTheme from "../AppTheme";
//import OnboardingConfirmDialog from "../onboarding/OnboardingConfirmDialog";
import appStyles from "../../appStyles";
import RoutinesIcon from "../common/icons/RoutinesIcon";
import ManaIcon from "../common/icons/ManaIcon";
import appPages from "../../../appPages";
import MariTalkingIcon from "../common/ActionsMenuButton/mari/MariTalkingIcon";

export default function PageMoreCards({ controller }) {
  const [weeksActive, setWeeksActive] = useState(0);
  const [journalEntries, setJournalEntries] = useState(0);
  const [goalsSet, setGoalsSet] = useState(0);

  //const [openConfirmation, setOpenConfirmation] = useState(false);

  const { is_enabled } = controller.state.settings || {};

  useEffect(() => {
    setWeeksActive(controller.state?.stats?.weeks_active);
    setJournalEntries(controller.state?.stats?.journal_entries);
    setGoalsSet(controller.state?.stats?.goals_set);
  }, [controller.state?.stats]);

  const closePage = (allowChangePage = true) => {
    if (controller.navigation != null) {
      controller.navigation.closeDrawer();
    } else if (allowChangePage) {
      controller.changePage("rn:home_card");
    }
  };

  const goTo = (page, showFooter) => {
    if (controller.navigation != null && AppConfig.USE_DRAWER) {
      controller.navigation.closeDrawer();
    }

    if (showFooter) {
      controller.navigate(page);
    } else {
      navigate(controller, page, "changepage", {});
    }
  };

  const autoTrack = () => {
    const action = {
      action: "autotrack",
      fillAverage: true,
    };
    controller.cardAction(action);
    closePage();
  };

  const goToChatRoom = () => {
    controller.tracking.track("Start Mari Chat");
    navigate(controller, "coaching_room", "changepage", {});
  };

  return (
    <>
      {/* Confirm AutoTrack Dialog */}
      {/* <OnboardingConfirmDialog
        isOpen={openConfirmation}
        title="Are you sure?"
        description="Tapping confirm will auto track your time up to now"
        onConfirm={() => {
          setOpenConfirmation(false);
          autoTrack();
        }}
        onClose={() => setOpenConfirmation(false)}
      /> */}

      <View style={styles.header}>
        <View style={styles.cardsContainer}>
          <TouchableOpacity
            style={styles.card}
            onPress={() => goTo(appPages.trackHome, true)}
          >
            <Text style={styles.cardNumber}>{weeksActive | 0}</Text>
            <Text style={styles.cardText}>Weeks Active</Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={styles.card}
            onPress={() => goTo(appPages.reflectionPage, true)}
          >
            <Text style={styles.cardNumber}>{journalEntries | 0}</Text>
            <Text style={styles.cardText}>Journal Entries</Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={styles.card}
            onPress={() => goTo(appPages.resolutionPage, true)}
          >
            <Text style={styles.cardNumber}>{goalsSet | 0}</Text>
            <Text style={[styles.cardText, { maxWidth: "50%" }]}>
              Goals Set
            </Text>
          </TouchableOpacity>

          {is_enabled ? (
            <TouchableOpacity onPress={() => goTo(appPages.routinesPage)}>
              <View style={styles.card}>
                <RoutinesIcon width={30} height={30} />
                <Text style={[styles.cardText]}>Manage Routines</Text>
              </View>
            </TouchableOpacity>
          ) : null}

          <TouchableOpacity onPress={goToChatRoom}>
            <View style={styles.card}>
              <MariTalkingIcon
                onPress={goToChatRoom}
                style={styles.imageIcon}
                fillColor={AppTheme.DEFAULT_COLOR}
                width="100%"
                height="100%"
              />
              <Text style={styles.cardText}>Chat with Mari</Text>
            </View>
          </TouchableOpacity>

          <TouchableOpacity onPress={() => goTo(appPages.elementsPage)}>
            <View style={styles.card}>
              <ManaIcon />
              <Text style={styles.cardText}>All Elements</Text>
            </View>
          </TouchableOpacity>

          {/* placeholder for ui */}
          {is_enabled ? null : (
            <View
              style={{
                width: 92,
                height: 81,
              }}
            />
          )}
        </View>
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  header: {
    position: "relative",
    minHeight: 190,
    backgroundColor: AppTheme.headerBg,
    paddingBottom: 0,
    paddingTop: 0,
  },
  backIcon: {
    marginRight: 0,
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  emailText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#2D3142",
  },
  guideText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#676C78",
    marginTop: 8,
  },
  cardsContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    paddingHorizontal: isWeb ? 42 : 32,
    ...appStyles.maxWidth,
    marginTop: 6,
  },
  card: {
    width: 92,
    height: 81,
    backgroundColor: "#F4F6FA",
    borderRadius: 4,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 8,
    paddingVertical: 10,
  },
  cardNumber: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 26,
    lineHeight: 35,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
  cardText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "500",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    textAlign: "center",
    maxWidth: "70%",
  },
  imageIcon: {
    width: 30,
    height: 30,
    marginBottom: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});
